import classNames from 'classnames';

import { Select } from '../../atoms';

type CurrencyOption = {
  value: string;
  label: string;
  iconSrc: string;
  disabled?: boolean;
};

export type CurrencySelectProps = {
  isMobile?: boolean;
  options: CurrencyOption[];
  currency: string;
  disabled?: boolean;
  onSelect: (selectedCurrency: CurrencyOption['value']) => void;
};

export const CurrencySelect = ({ options, currency, onSelect, disabled, isMobile }: CurrencySelectProps) => (
  <Select
    className={classNames('currency-select', { mobile: isMobile })}
    name={isMobile ? 'currency-select-mobile' : 'currency-select'}
    borderless
    withIcons
    disabled={disabled}
    options={options}
    value={currency}
    onValueChange={onSelect}
  />
);
